import { render, staticRenderFns } from "./LettersDisplay.vue?vue&type=template&id=9f21803c&scoped=true&"
import script from "./LettersDisplay.vue?vue&type=script&lang=js&"
export * from "./LettersDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LettersDisplay.vue?vue&type=style&index=0&id=9f21803c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f21803c",
  null
  
)

export default component.exports